// Disposable-email rule, mirrored from the backend (BLOCK_DISPOSABLE_EMAILS + blocked_email_domains table).
// The list is fetched once in the browser; the backend still enforces the rule on every submit,
// so a form that validates before the list has arrived is simply caught by the server instead.
import { API_URL } from "@/lib/apiUrl";

export const BLOCKED_EMAIL_MESSAGE = "Temporary or disposable email addresses are not allowed. Please use your regular email address.";

let blocked: string[] = [];
let started = false;

function load() {
  if (started || typeof window === "undefined") return;
  started = true;
  fetch(`${API_URL}/email-domains`)
    .then((r) => (r.ok ? r.json() : null))
    .then((j) => {
      if (j?.data?.enabled && Array.isArray(j.data.domains)) blocked = j.data.domains.map((d: string) => d.toLowerCase());
    })
    .catch(() => {
      started = false; // try again on the next validation
    });
}

/** Returns the error message when the address uses a blocked domain, otherwise "". */
export function blockedEmailError(email: string): string {
  load();
  const domain = email.trim().toLowerCase().split("@").pop() ?? "";
  return blocked.some((d) => domain === d || domain.endsWith(`.${d}`)) ? BLOCKED_EMAIL_MESSAGE : "";
}

// Start fetching as soon as any form importing this module loads in the browser.
load();
